<template>
  <div
    v-report="{
      id: 'hover',
      params: {
        status: isLogin ? 'login' : 'logout',
        ...publicReport,
      },
    }"
    class="index-container"
  >
    <div
      v-if="!isShowCloseButton"
      :class="isEvo ? 'triangle-container-evo' : 'triangle-container'"
    >
      <ImageView
        v-if="isEvo"
        class="triangle"
        :src="triangle"
        :style="triangleStyle"
      />
      <div
        v-else
        class="triangle-div"
        :style="triangleStyle"
      />
    </div>
    <HasLogin v-show="isLogin" />
    <NoLogin v-show="!isLogin" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useLoginStore } from '@/store';
import { LoginStatus } from '@/common/const';
import { isMac } from '@/common/utils';
import triangle from '@/assets/img/triangle.png';


import HasLogin from '@/components/has-login/index.vue';
import NoLogin from '@/components/no-login/index.vue';
import ImageView from '@/components/image-view.vue';

const loginStore = useLoginStore();
const { loginStatus, publicReport, offset } = storeToRefs(loginStore);
const isShowCloseButton = computed(() => loginStore.isShowCloseButton);
const isLogin = computed(() => loginStatus.value === LoginStatus.LOGIN);
const isEvo = import.meta.env.EVO;

const triangleStyle = computed(() => {
  const triangleColor = isLogin.value ? loginStore.cardStyle.triangleColor : '#1f1f1f';
  const style: any = {};
  if (!isEvo) {
    style.marginLeft = isLogin.value ? '285px' : '274px';
    style.borderBottom = `10px solid var(--tint-color, ${triangleColor})`;
  }
  if (isMac) {
    style.marginLeft = `${offset.value * 2}px`;
  }
  return {
    'tint-color': triangleColor,
    '--tint-color': triangleColor,
    ...style,
  };
});

</script>

<style lang="scss" scoped>
.triangle-container-evo {
  width: 100%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  .triangle {
    height: 11px;
  }
}
.triangle-container {
  display: flex;
  align-items: center;
  height: 10px;
  .triangle {
    margin-top: 2px;
    height: 10px;
  }
  .triangle-div {
    margin-top: 2px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
  }
}

.index-container {
  color: white;
  width: 100%;
  height: 100%;
}
</style>
